<template>
  <v-expansion-panel class="app-expansion-panel">
    <v-expansion-panel-header
      class="app-expansion-panel__header"
    >
      <slot name="title" />
      <template #actions>
        <v-icon color="primary">
          mdi-chevron-down
        </v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="app-expansion-panel__content">
      <slot name="tabs" />
      <div class="ma-5">
        <slot />
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'AppExpansionPanel',
}
</script>

<style scoped>
.app-expansion-panel::before {
  box-shadow: none !important;
}
  
.app-expansion-panel.v-expansion-panel:not(:first-child)::after {
  display: none;
}

.app-expansion-panel__header {
  background-color: #F2F1FF;
  color: #56565B;
  font-size: 14px;
  font-family: Roboto; 
  min-height: 64px;
}

.app-expansion-panel__header:not(.v-expansion-panel-header--active) {
  border-radius: 8px;
}

.app-expansion-panel__header.v-expansion-panel-header--active {
  border-radius: 8px 8px 0 0;
}

.app-expansion-panel__content {
  border: 0.5px solid rgba(217, 217, 217, 0.57);   
  border-radius: 0 0 8px 8px;
  box-shadow: 0px 4px 4px -4px rgba(0, 0, 0, 0.05); 
}

::v-deep.app-expansion-panel__content > .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>